// YouTube's red play mark (GitHub issue #4041): its brand colours, in both themes. Its own module so the edit-song
// pop-up can use it without the player's modules.
export function YouTubeMark({ width, height }: { width: number; height: number }) {
  return (
    <svg aria-hidden="true" width={width} height={height} viewBox="0 0 24 17">
      <path
        fill="#d21f1f"
        d="M23.5 2.7A3 3 0 0 0 21.4.6C19.5.1 12 .1 12 .1S4.5.1 2.6.6A3 3 0 0 0 .5 2.7C0 4.6 0 8.5 0 8.5s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8z"
      />
      <path fill="#fff" d="M9.6 12.1l6.2-3.6-6.2-3.6z" />
    </svg>
  );
}
